import { Box, Flex, FormControl, Image, Spinner } from "@chakra-ui/react";
import {
  LinkText,
  AuthFormContainer,
  AuthCardEllipse,
  AuthCardTopFrame,
  KpecLogoText,
  AuthHeading,
  AuthSubheading,
  AuthFieldsWrapper,
  AuthInputBox,
  AuthInputField,
  AuthLabelText,
  AuthButton,
  AuthButtonWrapper,
  AuthLinkText,
} from "@root/commonStyles/commonStyle";
import { ROUTE_NAMES, USER_TYPES } from "@root/constants";
import { updatePasswordRecoverEmail } from "@root/store/slices/entities";
import { resetPass } from "@root/store/thunks";
import { Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { useOrganizationBranding } from "@root/context/organization-branding-context";

export const ForgotPassword: React.FC = () => {
  const { t } = useTranslation("common");
  const { logoUrl, defaultLogoUrl, loading: brandingLoading } = useOrganizationBranding();
  const [loading, setLoading] = useState(false);
  const isLoggedInUser: any = useSelector(getLoggedInUser);
  const initialValues = {
    email: "",
  };
  const redirect_url = `${process.env.REACT_APP_FRONTEND_URL}${ROUTE_NAMES.RESET_PASSWORD}/`;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onSuccess = (email: string) => {
    setLoading(false);
    navigate(ROUTE_NAMES.CHECK_YOUR_EMAIL);
    dispatch(updatePasswordRecoverEmail(email));
  };
  const onSubmitHandler = (values: any) => {
    setLoading(true);
    dispatch(
      resetPass({
        payload: {
          email: values?.email,
        },
        onSuccess: () =>
          onSuccess({
            email: values?.email,
          } as any),
        onError: () => setLoading(false),
      })
    );
  };
  return (
    <AuthFormContainer>
      <AuthCardEllipse />
      <AuthCardTopFrame>
        <Flex align="center" gap="12.8px" minH="38px">
          {brandingLoading ? (
            <Spinner size="md" />
          ) : (
            <Image src={logoUrl || defaultLogoUrl} alt="logo" maxH="38px" objectFit="contain" />
          )}
        </Flex>
        <Flex direction="column" align="stretch" width="100%" gap="10px">
          <AuthHeading>{t("forgetPassword.forgetPassword")}</AuthHeading>
          <AuthSubheading>{t("forgetPassword.subHeading")}</AuthSubheading>
        </Flex>
      </AuthCardTopFrame>

      <Formik initialValues={initialValues} onSubmit={onSubmitHandler}>
        {({ handleSubmit, errors, touched, values, setFieldValue }) => (
          <form onSubmit={handleSubmit} style={{ width: "100%" }}>
            <AuthFieldsWrapper>
              <Flex
                direction="column"
                align="flex-start"
                gap="1rem"
                width="100%"
              >
                <Flex
                  direction="column"
                  align="flex-start"
                  gap="0.5rem"
                  width="100%"
                >
                  <AuthLabelText>{t("forgetPassword.email")}</AuthLabelText>
                  <FormControl
                    isInvalid={!!errors.email && touched.email}
                    width="100%"
                  >
                    <AuthInputBox>
                      <AuthInputField
                        id="email"
                        name="email"
                        type="email"
                        required
                        placeholder={t("forgetPassword.phEmail")}
                        value={values.email}
                        onChange={(e: React.ChangeEvent<any>) =>
                          setFieldValue("email", e.target.value)
                        }
                      />
                    </AuthInputBox>
                  </FormControl>
                </Flex>
              </Flex>
            </AuthFieldsWrapper>

            <AuthButtonWrapper>
              <AuthButton
                type="submit"
                isLoading={loading}
                rightIcon={<ArrowForwardIcon boxSize="5" color="white" />}
              >
                {t("forgetPassword.continue")}
              </AuthButton>
            </AuthButtonWrapper>
          </form>
        )}
      </Formik>

      <AuthLinkText
        my="0px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap="2px"
        onClick={() => {
          // On forgot password page, no user is logged in
          // Navigate back to the previous login page from browser history or default to journalist login
          navigate(-1);
        }}
        color="#1819B4"
        _hover={{ textDecoration: "underline" }}
      >
        <ArrowBackIcon boxSize="20px" color="#1819B4" />
        {t("forgetPassword.backToLogin")}
      </AuthLinkText>
    </AuthFormContainer>
  );
};
